<template>
  <CDropdown variant="nav-item" placement="bottom-end">
    <CDropdownToggle class="py-0" :caret="false">
      <CAvatar :src="avatar" size="md" />
    </CDropdownToggle>

    <CDropdownMenu class="account-menu pt-0">
      <CDropdownHeader
        v-if="userName || userEmail"
        component="div"
        class="bg-light py-2"
      >
        <div v-if="userName" class="fw-semibold account-name">
          {{ userName }}
        </div>
        <div v-if="userEmail" class="small text-medium-emphasis account-email">
          {{ userEmail }}
        </div>
      </CDropdownHeader>

      <CDropdownItem href="#" class="logout-item" @click.prevent="logout">
        <CIcon icon="cil-lock-locked" />
        <span>Sair</span>
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import avatar from '@/assets/images/avatars/user.png'
import AuthService from '@/services/auth.service'
import { getUserInfo } from '@/utils/auth'

export default defineComponent({
  name: 'AppHeaderDropdownAccnt',
  setup() {
    const router = useRouter()
    const user = getUserInfo()

    const userName = computed(() => user?.nameAdm || '')
    const userEmail = computed(() => user?.emailAdm || '')

    const logout = () => {
      AuthService.logout()
      router.replace('/login')
    }

    return {
      avatar,
      logout,
      userEmail,
      userName,
    }
  },
})
</script>

<style scoped>
.account-menu {
  min-width: 230px;
}

.account-name,
.account-email {
  max-width: 205px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logout-item {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}
</style>
